import React from "react";
import { FormattedMessage } from "react-intl";
import { Row, Select, Space } from "@masterteam/mt-design-react";

import KPIStatusIndicator from "../../KPIStatusIndicator";
import useIsAr from "../../../Hooks/useIsAr";

import "./style.scss";

const Header = ({
  isLoading,
  strategies,
  kpiStatuses,
  setSelectedStrategy,
  selectedStrategy,
}) => {
  const [isAr] = useIsAr();

  return (
    <Row justify="between" align="center" className="header-wrapper">
      <Space align="center" className="strategy-select-wrapper">
        <FormattedMessage id="common.strategy" />

        <div className="select">
          <Select
            value={selectedStrategy}
            getOptionLabel={(el) => (isAr ? el.ArabicName : el.EnglishName)}
            getOptionValue={(el) => el?.ID}
            onChange={(e) => setSelectedStrategy(e)}
            isLoading={isLoading}
            options={strategies}
          />
        </div>
      </Space>

      <Space size="medium">
        <div className="kpi-label">
          <FormattedMessage id="common.kpi-status" /> :
        </div>
        <Space size="medium">
          {kpiStatuses.map((_item) => (
            <KPIStatusIndicator
              item={_item}
              list={kpiStatuses}
              key={_item?.ID}
            />
          ))}
        </Space>
      </Space>
    </Row>
  );
};

export default Header;
